import React from 'react';
import { Grid, Header } from 'semantic-ui-react';

export default function CallbackSuccessPage(){
    return (
        <Grid verticalAlign="middle" centered style={{'padding': '120px'}}>
            <Grid.Row>
                <Grid.Column>
                    <Header size="large" color="green">Success!</Header>
                    <Header size="medium">Your payment details have been saved.</Header>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}
